import Masonry from "react-masonry-css";
import React, { ChangeEvent, FC, useState } from "react";

import RoleTitleGroup from "../RoleTitleGroup";
import classes from "../../RoleTitleSelectionSlide.module.scss";
import { CookieSet, RoleTitleGroup as RoleTitleGroupType } from "../../../../../types/campaignTypes";

type SetStateAction<S> = S | ((prevState: S) => S);
type CheckBoxes = Record<string, boolean>;
type SelectedCookieSets = Record<string, CookieSet[]>;

type RoleTitleSelectionDashboardProps = {
  roleTitleList: RoleTitleGroupType[];
  selectedCookieSets: SelectedCookieSets;
  setSelectedCookieSets: (selectedCookieSets: SetStateAction<SelectedCookieSets>) => void;
};

const RoleTitleSelectionDashboard: FC<RoleTitleSelectionDashboardProps> = ({
  roleTitleList,
  selectedCookieSets,
  setSelectedCookieSets,
}) => {
  const [checkBoxes, setCheckBoxes] = useState<CheckBoxes>(() => {
    const haveSelectedRoleTitles = !!Object.values(selectedCookieSets).find((val) => val.length);

    const baseCheckBoxesState = roleTitleList.reduce((accum, roleTitleGroup) => {
      const roleSetCheckBoxValues = roleTitleGroup.roleSet.reduce((roleSetAccum, roleSet) => {
        return {
          ...roleSetAccum,
          [`${roleTitleGroup.roleTypeId}:${roleSet.roleId}`]: false,
        };
      }, {});

      return {
        ...accum,
        ...roleSetCheckBoxValues,
      };
    }, {});

    if (haveSelectedRoleTitles) {
      const checkBoxesValues: CheckBoxes = {};
      // eslint-disable-next-line array-callback-return
      Object.entries(selectedCookieSets).map(([key, value]) => {
        checkBoxesValues[key] = !!value.length;
      });
      return {
        ...baseCheckBoxesState,
        ...checkBoxesValues,
      };
    }

    return baseCheckBoxesState;
  });

  const handleChange = (cookieSet: CookieSet[]) => (event: ChangeEvent<{}>) => {
    const { name } = event.target as HTMLInputElement;

    setCheckBoxes((prevCheckBoxes) => ({
      ...prevCheckBoxes,
      [name]: !prevCheckBoxes[name],
    }));

    setSelectedCookieSets((prevSelectedCookieSets) => {
      const isChecked = !!prevSelectedCookieSets[name] && prevSelectedCookieSets[name].length > 0;

      if (isChecked) {
        const { [name]: _, ...rest } = prevSelectedCookieSets;
        return rest;
      }
      return {
        ...prevSelectedCookieSets,
        [name]: cookieSet,
      };
    });
  };

  const handleSelectAll = (roleTitleGroup: RoleTitleGroupType) => (event: ChangeEvent<{}>) => {
    const { name } = event.target as HTMLInputElement;
    const { roleSet, roleTypeId } = roleTitleGroup;

    const checked = !!checkBoxes[name];
    const cookieSets: any = {};
    let allCookieSets: CookieSet[] = [];
    const checkboxNames: any = {};

    for (const element of roleSet) {
      const key = `${roleTypeId}:${element.roleId}`;

      if (checked) {
        cookieSets[key as keyof typeof cookieSets] = [];
        checkboxNames[key as keyof typeof cookieSets] = false;
        allCookieSets = [];
      } else {
        cookieSets[key as keyof typeof cookieSets] = element.cookieSets;
        checkboxNames[key as keyof typeof cookieSets] = true;
        allCookieSets = allCookieSets.concat(element.cookieSets);
      }
    }

    setCheckBoxes((prevState) => ({
      ...prevState,
      ...checkboxNames,
      [name]: !checked,
    }));

    setSelectedCookieSets((prevState) => ({
      ...prevState,
      // @ts-ignore
      ...cookieSets,
      [name]: allCookieSets,
    }));
  };

  return (
    <div className={classes.dasboardContainer}>
      <Masonry breakpointCols={4} className={classes.masonryGrid} columnClassName={classes.masonryGridColumn}>
        {roleTitleList.map((roleTitleGroup) => (
          <RoleTitleGroup
            handleSelectAll={handleSelectAll}
            handleChange={handleChange}
            checkBoxes={checkBoxes}
            roleTitleGroup={roleTitleGroup}
            key={roleTitleGroup.roleType}
          />
        ))}
      </Masonry>
    </div>
  );
};

export default RoleTitleSelectionDashboard;
